import vQuote from "./v-quote.vue";

export default Vue => {
  Vue.component("v-quote", vQuote);
};
